import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography, Button } from "@mui/material";
import { theme } from "../../components/muiTheme"
import { useAuthDispatch, useAuthStore } from "../../contexts/AuthContext";
import {logout} from "../../apiCalls/auth";
import HeaderWithBackandLogout from "../main/HeaderWithBackandLogout";
import DropdownButton from "../../components/reusable-components/buttons/DropdownButton";
import { useTrack } from "../../analytics/hooks";

export default function AccountJoinPage() {
  const { user, selectedAccount } = useAuthStore();
  const authDispatch = useAuthDispatch();
  const navigate = useNavigate();
  const track = useTrack();
  const [cancelJoinConfirmPage, setCancelJoinConfirmPage] = useState(false);

  const handleJoin = () => {
    fetch(
      `/api/accounts/join`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ schoolId: selectedAccount?.id }),
      }
    )
      .then(response => response.json())
      .then(data => {
        if(data.eventsCreated){
          authDispatch({type: "updateAuth", payload: {requestToJoin: true}})
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }

  track("registration_request_to_join_presented", {
    user: user,
    account: selectedAccount
  });


  const handleConfirmCancelJoin = () => {
    fetch(
      `/api/accounts/join`,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ accountId: selectedAccount?.id }),
      }
    )
      .then(response => response.json())
      .then(data => {
        if(data.eventsCreated){
          authDispatch({
            type: "updateAuth",
             payload: {
              requestToJoin: false, 
              joinRequestRevoked: true,
              Accounts: [],
              UserRoles: {}
            }}
          )
          navigate("/", { replace: true });
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }

  const handleNotRequest = () => {
    authDispatch({
      type: "setSelectedAccount",
      payload: null,
    })
  }

  return user.requestToJoin || user.joinRequestRevoked ? (
    <Grid
      container
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Grid
        item
        sx={{
          width: "365px",
          height: "149px",
          padding: "26px 28px",
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
        }}>
        <Grid
          container
          direction="column"
          sx={{
            width: "100%",
            height: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Grid
            item
            sx={{
              width: "100%",
            }}>
            <Typography
              sx={{
                textAlign: "left",
                fontFamily: "Lato",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "normal",
                color: "var(--Blacks-500, #100C08)",
              }}>
              {user.joinRequestRevoked
                ? "Your request has been successfully revoked. The school will not proceed with processing your request."
                : cancelJoinConfirmPage
                ? "Are you sure you want to revoke this request? This action cannot be undone."
                : `Your request to join ${selectedAccount?.name} has been successfully sent to the school owner. You will receive an email notification once you've been invited.`}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              width: "100%",
              height: "34px",
            }}>
            <Grid
              container
              sx={{
                width: "100%",
                height: "100%",
                justifyContent: "space-between",
                alignContent: "center",
              }}>
              {user.joinRequestRevoked ? (
                <Grid
                  item
                  sx={{
                    width: "100%",
                    height: "100%",
                  }}>
                  <DropdownButton
                    type="primary"
                    variant="text"
                    clickFunc={logout}>
                    Logout
                  </DropdownButton>
                </Grid>
              ) : (
                <>
                  <Grid
                    item
                    sx={{
                      width: cancelJoinConfirmPage ? "131px" : "153px",
                      height: "100%",
                    }}>
                    <DropdownButton
                      type={cancelJoinConfirmPage ? "primary" : "error"}
                      variant={cancelJoinConfirmPage ? "text" : "outlined"}
                      clickFunc={() =>
                        setCancelJoinConfirmPage(!cancelJoinConfirmPage)
                      }>
                      {cancelJoinConfirmPage ? " Cancel" : "Revoke Request"}
                    </DropdownButton>
                  </Grid>
                  <Grid
                    item
                    sx={{
                      width: cancelJoinConfirmPage ? "175px" : "153px",
                      height: "100%",
                    }}>
                    <DropdownButton
                      type={cancelJoinConfirmPage ? "error" : "primary"}
                      variant={cancelJoinConfirmPage ? "outlined" : "text"}
                      clickFunc={() => {
                        cancelJoinConfirmPage
                          ? handleConfirmCancelJoin()
                          : logout();
                      }}>
                      {cancelJoinConfirmPage ? "Yes, Revoke Request" : "Logout"}
                    </DropdownButton>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <Grid
      item
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "#FFFFFF",
        padding: "20px",
      }}>
      <Grid container sx={{ height: "100%", width: "100%" }}>
        <Grid item xs={12} md={6} sx={{ height: "100%" }}>
          <Grid
            container
            direction="column"
            sx={{
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              overflowY: "auto",
            }}>
            {/* <HeaderWithBackandLogout handleBack={handleBack} /> */}
            <Grid
              item
              sx={{
                height: "auto",
                width: "350px",
                padding: "87px 0 87px 0",
              }}>
              <Grid
                container
                direction="column"
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "20px",
                }}>
                <Grid item sx={{ width: "100%", marginBottom: "44px" }}>
                  <Grid
                    container
                    direction="column"
                    sx={{
                      width: "100%",
                      height: "auto",
                      justifyContent: "space-between",
                    }}>
                    <Grid item sx={{ marginBottom: "44px" }}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          font: "normal normal bold 25px/30px Lato",
                          letterSpacing: "0px",
                        }}>
                        <>
                          <span style={{ color: "#161A1D" }}>
                            Request to Join{" "}
                          </span>
                          <span style={{ color: "#AC5CCC" }}>
                            {selectedAccount?.name}?
                          </span>
                        </>
                      </Typography>
                    </Grid>
                    <Grid item sx={{ width: "100%", marginBottom: "12px" }}>
                      <Typography
                        sx={{
                          textAlign: "left",
                          color: "var(--Blacks-500, #100C08)",
                          fontFamily: "Lato",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "21px",
                          marginBottom: "22px",
                        }}>
                        Would you like to send a request to the school owner to
                        join {user?.account?.name}? Your request will be sent
                        directly to them for review.
                      </Typography>

                      <Grid
                        item
                        sx={{
                          width: "100%",
                          height: "41px",
                          padding: "12px 20px",
                          borderRadius: "10px",
                          border: "1px solid var(--Neutrals-500, #E2E6E9)",
                        }}>
                        <Typography
                          sx={{
                            color: "var(--Primary-900, #0B0926)",
                            fontFamily: "Lato",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "normal",
                          }}>
                          {selectedAccount?.name || "School Name"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sx={{ height: "60px", width: "100%",  marginBottom: "44px" }}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleJoin}
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "6px",
                      backgroundColor: "var(--Primary-500, #16124C)",
                    }}>
                    <Typography
                      sx={{
                        ...theme.typography.buttonText1,
                        color: "white",
                      }}>
                      Request to Join
                    </Typography>
                  </Button>
                </Grid>
                <Grid item sx={{ height: "17px", marginBottom: "44px" }}>
                  <Typography
                    sx={{
                      color: "var(--Primary-900, #0B0926)",
                      fontFamily: "Lato",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "normal",
                    }}>
                    <>
                      <span style={{ color: "var(--Primary-500, #16124C)" }}>
                        Changed your mind?{" "}
                      </span>
                      <span
                        style={{
                          color: "var(--Tertiary-500, #00A6FF)",
                          cursor: "pointer",
                        }}
                        onClick={handleNotRequest}>
                        Don’t send the request
                      </span>
                    </>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={6}
          className="requestojoin-image-section"
          sx={{
            height: "100%",
            display: { xs: "none", md: "block" },
          }}>
          {/* left image here */}
          <img
            src="/images/Product_registration-01.png"
            alt="request to join"
            className="requestojoin-image"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              borderRadius: "6px",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
